export const OPENROUTER_MODEL_ID = 'moonshotai/kimi-k2.5';
export const SESSION_AGENT_HOST = 'api.okrapdf.com';
export const DEFAULT_CREATE_PROMPT = 'Create a PDF brief from my uploaded files.';
export const MAX_INLINE_CREATE_FILE_BYTES = 10 * 1024 * 1024;
export const PROMPT_FILE_PREVIEW_CHARS = 4_000;
export const CREATE_TEXT_PREVIEW_MAX_CHARS = 100_000;
export const CREATE_PDF_PREVIEW_MAX_PAGES = 3;
export const CREATE_PDF_PREVIEW_MAX_WIDTH = 760;
export const CREATE_SHEET_PREVIEW_MAX_SHEETS = 3;
export const CREATE_SHEET_PREVIEW_MAX_ROWS = 40;
export const CREATE_SHEET_PREVIEW_MAX_COLS = 14;
export const CREATE_PAGE_CONFIG = {
  showInspectorPanel: false,
} as const;
export const CREATE_MOBILE_WORKSPACE_GRID_CLASS = 'grid min-h-0 flex-1 grid-cols-1 grid-rows-1 overflow-hidden';
export const CREATE_DESKTOP_WORKSPACE_GRID_CLASS = CREATE_PAGE_CONFIG.showInspectorPanel
  ? 'grid min-h-0 flex-1 grid-cols-[390px_minmax(260px,320px)_minmax(420px,1fr)_360px] grid-rows-none gap-2 overflow-x-auto overflow-y-hidden p-2'
  : 'grid min-h-0 flex-1 grid-cols-[390px_minmax(260px,320px)_minmax(420px,1fr)] grid-rows-none gap-2 overflow-x-auto overflow-y-hidden p-2';
export const CREATE_CODEMODE_GUIDANCE = [
  'Default Create output is render_image_pdf: a PDF assembled from OpenRouter openai/gpt-5.4-image-2 page images plus ReportLab page placement.',
  'Before rendering, read only the needed uploaded context progressively with read_create_asset and doc_sql.',
  'Use paperSize "a4" or "letter", orientation "portrait" or "landscape", and pageCount 1-6.',
  'The server enforces exact paper-like PDF page dimensions by fitting generated image bytes into fixed ReportLab pages.',
  'Use render_pdf/codemode only if the user explicitly asks for editable codemode or deterministic programmatic layout, and use pdf.render or pdf.reportLab instead of browser HTML.',
].join('\n');

export const MIME_BY_EXTENSION: Record<string, string> = {
  csv: 'text/csv',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  gif: 'image/gif',
  html: 'text/html',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  json: 'application/json',
  md: 'text/markdown',
  pdf: 'application/pdf',
  png: 'image/png',
  svg: 'image/svg+xml',
  text: 'text/plain',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  txt: 'text/plain',
  webp: 'image/webp',
  xml: 'application/xml',
  xls: 'application/vnd.ms-excel',
  xlsb: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  yaml: 'application/yaml',
  yml: 'application/yaml',
};

export const TEXT_LIKE_EXTENSIONS = new Set([
  'csv',
  'html',
  'json',
  'md',
  'svg',
  'text',
  'txt',
  'xml',
  'yaml',
  'yml',
]);

export const SPREADSHEET_EXTENSIONS = new Set(['csv', 'ods', 'tsv', 'xls', 'xlsb', 'xlsm', 'xlsx']);
